// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mXFR","col":"styles_col__1GSxS"};